var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsageTransactionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.998 9.36264C14.998 9.01859 14.7145 8.74023 14.364 8.74023H8.87877C8.62252 8.74023 8.39091 8.89238 8.29228 9.12492C8.19454 9.35833 8.24825 9.62544 8.42966 9.80352L9.44586 10.8002C9.57003 10.9221 9.73205 10.9826 9.89409 10.9826C10.0561 10.9826 10.219 10.9221 10.3432 10.7994C10.5695 10.5772 10.5889 10.2297 10.4013 9.98505H14.3631C14.7136 9.98505 14.998 9.7067 14.998 9.36264Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24609 6.63692C8.24609 6.98098 8.52964 7.25933 8.88012 7.25933H14.3654C14.6216 7.25933 14.8532 7.10718 14.9519 6.87464C15.0496 6.64124 14.9959 6.37413 14.8145 6.19604L13.7983 5.19846C13.5499 4.95468 13.1493 4.95468 12.9018 5.19846C12.6746 5.42149 12.6561 5.76986 12.8437 6.01365H8.88103C8.52967 6.01365 8.24609 6.29286 8.24609 6.63692Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12788 15.4998H9.44675C10.883 15.4998 12.1274 14.5489 12.4707 13.1883C12.483 13.1391 12.4892 13.0889 12.4892 13.0379V11.7672C12.4892 11.4231 12.2057 11.1447 11.8552 11.1447C11.5047 11.1447 11.2211 11.4231 11.2211 11.7672V12.9566C10.9939 13.7243 10.2745 14.2551 9.44585 14.2551L4.12789 14.2542C3.10199 14.2542 2.26806 13.439 2.26806 12.4363V3.5705C2.26806 2.5634 3.10286 1.74476 4.12789 1.74476H9.44676C10.286 1.74476 11.0283 2.3153 11.237 3.11061V4.13586C11.237 4.47991 11.5206 4.75826 11.871 4.75826C12.2215 4.75826 12.5051 4.47991 12.5051 4.13586V3.038C12.5051 2.99305 12.4998 2.9481 12.4901 2.90488C12.1775 1.51137 10.8971 0.5 9.44675 0.5H4.12788C2.40368 0.5 1 1.87795 1 3.57055V12.4363C1 14.1255 2.40368 15.4998 4.12788 15.4998Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08748 3.77051H4.99341C4.64292 3.77051 4.35938 4.04886 4.35938 4.39292C4.35938 4.73697 4.64292 5.01533 4.99341 5.01533H7.08748C7.43796 5.01533 7.72151 4.73697 7.72151 4.39292C7.72151 4.04886 7.43796 3.77051 7.08748 3.77051Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageTransactionsIcon);
export default __webpack_public_path__ + "static/media/usage-transactions-icon.fd5a433ce102b7f134bee0cd3a3e58fd.svg";
export { ForwardRef as ReactComponent };